import React from "react";
import { connect } from "react-redux";
import { MetypeCommentingWidget } from "@metype/components";
import get from "lodash/get";
import { object } from "prop-types";

import generateHostStoryUrl from "../utils/generate-story-url";

const MetypeCommentWrapperBase = ({ publisherAttributes = {}, story }) => (
  <div className="metype-comments-container">
    <MetypeCommentingWidget
      host={publisherAttributes["metypeHost"]}
      accountId={publisherAttributes["metypeAccountId"]}
      pageURL={generateHostStoryUrl(story)}
      primaryColor={publisherAttributes["primaryColor"]}
      className={publisherAttributes["className"]}
    />
  </div>
);

const mapStateToProps = state => {
  return {
    publisherAttributes: get(state, ["qt", "config", "publisher-attributes"], {})
  };
};

const MetypeCommentWrapper = connect(mapStateToProps)(MetypeCommentWrapperBase);

MetypeCommentWrapperBase.propTypes = {
  publisherAttributes: object,
  metypeConfig: object,
  story: object
};

export default MetypeCommentWrapper;
